export const FacebookV2Icon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.605 8.3775C16.5703 8.33797 16.5276 8.30619 16.4798 8.28422C16.432 8.26226 16.3801 8.2506 16.3275 8.25H13.5V7.1925C13.5 6.9825 13.545 6.7425 13.8825 6.7425H16.1325C16.182 6.74575 16.2316 6.73726 16.2772 6.71771C16.3228 6.69816 16.3632 6.66811 16.395 6.63C16.4287 6.59673 16.4554 6.55701 16.4735 6.51319C16.4915 6.46938 16.5005 6.42238 16.5 6.375V3.375C16.5 3.27554 16.4605 3.18016 16.3902 3.10983C16.3198 3.03951 16.2245 3 16.125 3H12.8775C9.2775 3 9 6.075 9 7.0125V8.25H7.125C7.02554 8.25 6.93016 8.28951 6.85984 8.35984C6.78951 8.43016 6.75 8.52554 6.75 8.625V11.625C6.75 11.7245 6.78951 11.8198 6.85984 11.8902C6.93016 11.9605 7.02554 12 7.125 12H9V20.625C9 20.7245 9.03951 20.8198 9.10983 20.8902C9.18016 20.9605 9.27554 21 9.375 21H13.125C13.2245 21 13.3198 20.9605 13.3902 20.8902C13.4605 20.8198 13.5 20.7245 13.5 20.625V12H16.0125C16.1058 12.0005 16.1959 11.9661 16.2652 11.9037C16.3346 11.8413 16.3782 11.7553 16.3875 11.6625L16.695 8.6625C16.7018 8.6113 16.6973 8.55924 16.6817 8.50999C16.6661 8.46074 16.64 8.41551 16.605 8.3775Z"
        fill="black"
      />
    </svg>
  )
}
